( () => {

    var $ = require( "jquery" );

    const site = {

        bootstrap: () => {

            site.initSlider()
            site.initScrollTo()

        },

        initSlider: () => {

            // Falls es mehrere Slider-Blöcke gibt, nehmen wir alle
            $('.slider').each( function() {

                $(this).slick( {

                    arrows: true,
                    dots: true,
                    infinite: true,
                    slidesToShow: 1,
                    fade: true,
                    cssEase: 'ease-in-out',
                    speed: 1000,
                    autoplay: true,
                    autoplaySpeed: 8000,
                    prevArrow: $( ".slick__button--left", $(this).parent() ),
                    nextArrow: $( ".slick__button--right", $(this).parent() ),
                    appendDots: $( ".slick__dots", $(this).parent() ),
                    dotsClass: ""

                } )

            } )

            $(".wp-block-gallery.is-slider").each( function() {

                /** 
                 * slidesToShow sollen per variabel sein, je nachdem,
                 * wie viele Spalten die Gallery hat.
                 */
                let slidesToShow = 1;

                $(this).attr("class").split(" ").forEach( function( className ) {

                    if( className.includes( "columns-" ) ) {
                        slidesToShow = parseInt( className.replace( "columns-", "" ) );
                    }

                } );

                $(this).slick( {
                    slidesToShow,
                    dots: false,
                    infinite: false,
                    slidesToScroll: slidesToShow,
                    prevArrow: '<a class="slick__button slick__button--left left-6 md:left-10"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/></svg></a>',
                    nextArrow: '<a class="slick__button slick__button--right right-6 md:right-10"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/></svg></a>',
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: Math.min(2, slidesToShow),
                            slidesToScroll: Math.min(2, slidesToShow),
                        }
                    }, {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: Math.min(4, slidesToShow),
                            slidesToScroll: Math.min(4, slidesToShow),
                        }
                    }]
                } );

            });

        },

        initScrollTo: () => {

            // Scroll-to-top nur anzeigen, wenn der Inhalt größer als der Bildschirm ist
            $(".js-scroll-to-top").toggle( $("body").height() > $(window).height() );

            // Click-Handler
            $(".js-scroll-to-top").on( 'click', () => $("html, body").animate({ scrollTop: 0 }, "slow") )

        }

    };

    $("document").ready( site.bootstrap )


} )();